(function () {
    'use strict';

    angular.module('app').controller('CorporateAccountsCategoryController', CorporateAccountsCategoryController);

    CorporateAccountsCategoryController.$inject = [
        '$rootScope',
        '$scope',
        '$filter',
        '$routeParams',
        '$uibModal',
        'CorporateCustomerService',
        'LANGS',
        'BusinessService',
        'NotifyService',
        'TaxesExemptInCorporateService',
        'SettingsService'];

    function CorporateAccountsCategoryController(
        $rootScope, $scope, $filter, $routeParams, $uibModal, CorporateCustomerService, LANGS, BusinessService, NotifyService,
        TaxesExemptInCorporateService, SettingsService) {
        $scope.model = {};
        $scope.data = {
            showDisabledCategories: false, showCategoryRuleDisabled: false
        };
        $scope.multilang = MultilanguageHelper();
        $scope.isPageMode = isPageMode;
        $scope.data = {
            showDisabledCategories: false, corporateCategories: []
        };

        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformSupportedLanguages(function (success, response) {
            $scope.platformSupportedLanguagesCodes = response;
        });

        initController();

        function initController() {
            $scope.multilang.initLangs(LANGS, $rootScope.LANG);

            initPageMode();
            getCorporateCategories();

            console.log($scope.data);
        }

        /**
         * Page mode display differed parts. Now 'show', 'create', 'edit'.
         * Use as <ANY ng-if="isPageMode('show')">
         */
        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        /**
         * Check parameter 'mode' in route ../pos/{mode}
         */
        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        /**
         * Initialize page mode by url
         */
        function initPageMode() {
            $scope._pageMode = 'show';
            if (isRouteMode('edit')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('customer_id')) ? 'edit' : 'show';
            } else if (isRouteMode('create')) $scope._pageMode = 'create';

            if (isRouteMode('fields')) $scope._pageMode = 'fields';
        }

        function getCorporateCategories() {
            CorporateCustomerService.GetCorporateCustomersCategories(function (success, data) {
                if (success) {
                    $scope.data.corporateCategories = [...data];
                }
            });

        }

        $scope.onCategoryToggleClick = function (c) {
            var cc = itemByIndex($scope.data.corporateCategories, c.id);
            cc.active = cc.active === 1 ? 0 : 1;

            // get category from server in order to have correct public title object
            CorporateCustomerService.GetCorporateCustomersCategoryById(cc.id, function (success, data) {
                if (success) {
                    cc.public_title = data.public_title;
                    // save active / inactive category
                    CorporateCustomerService.EditCorporateCustomersCategories(cc, function () {
                    });
                }
            });
        };

        $scope.editCategory = function (id) {
            CorporateCustomerService.GetCorporateCustomersCategoryById(id, function (success, data) {
                if (success) {
                    $scope.openModalCardCategory(data);
                }
            });
        };

        $scope.openModalCardCategory = function (category) {

            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                size: 'lg',
                templateUrl: 'app/templates/modal.corporate-add-edit-category.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {
                    console.log('category', category);
                    var popup = this;
                    popup.data = {
                        hideEnable: true
                    };
                    popup.ValueDependsCalcPeriod = {
                        'all': 'For all time',
                        'day': 'For day',
                        'week': 'For week',
                        'month': 'For months',
                        'three-month': 'For three months',
                        'year': 'For year',
                        'current-week': 'For this week (since Monday)',
                        'past-week': 'For last week (since Monday)',
                        'current-month': 'For current month (from the 1st)',
                        'past-month': 'For last month (from the 1st of the last month)',
                        'current-quarter': 'For current quarter',
                        'past-quarter': 'For last quarter',
                        'current-year': 'For current year (since January 1st)',
                        'past-year': 'For last year (since January 1st of the last year)'
                    };
                    popup.step = 0;
                    popup.platformSupportedLanguagesCodes = angular.copy($scope.platformSupportedLanguagesCodes);
                    popup.categoryLang = $scope.multilang.lang;
                    popup.isCorporateCategory = true;
                    popup.currentTab = 'add_edit_category';

                    popup.category = category ? category : {
                        active: 1,
                        active_change_allowed: true,
                        id: '',
                        public_title: {
                            en: '', pl: '', ru: '', uk: ''
                        },
                        title: '',
                        title_change_allowed: true,
                        weight_change_allowed: true,
                        weight: 1
                    };

                    popup.category.title_change_allowed = true;
                    popup.category.weight_change_allowed = true;
                    popup.corruptedFields = [];
                    popup.priceOptions = [];

                    popup.onDependsTypeSelect = function () {
                        if (popup.newPriceOption.value_depends_type === 'none') {
                            delete popup.newPriceOption.value_depends_matrix;
                            delete popup.newPriceOption.value_depends_calc_period;
                            delete popup.newPriceOption.value_depends_by_goods;
                            popup.validation.isValueValid = !!popup.newPriceOption.value;
                        } else {
                            if (!popup.newPriceOption.value_depends_matrix) {
                                popup.newPriceOption.value_depends_matrix = [
                                    {threshold: 0, value: null}
                                ];
                            }

                            if (!popup.newPriceOption.value_depends_calc_period) {
                                popup.newPriceOption.value_depends_calc_period = 'all';
                            }

                            if (!popup.newPriceOption.value_depends_by_goods) {
                                popup.newPriceOption.value_depends_by_goods = 'all';
                            }

                            popup.validation.isValueValid = true;
                        }
                    };
                    popup.isRuleValueCurrent = function (item) {
                        return item == popup.editingRule;
                    };
                    popup.ruleValueEditClick = function (value) {
                        popup.isRuleValueEdit = true;
                        popup.editingRule = value;
                        popup.backupRule = angular.copy(value);
                    };
                    popup.ruleValueDeleteClick = function (value) {
                        if (popup.newPriceOption.value_depends_matrix.length === 1) {
                            popup.newPriceOption.value_depends_matrix = [
                                {threshold: 0, value: null}
                            ];

                            popup.ruleValueEditClick(popup.newPriceOption.value_depends_matrix[0]);
                            return;
                        }
                        popup.newPriceOption.value_depends_matrix.forEach(function (item) {
                            if (item == value) {
                                popup.newPriceOption.value_depends_matrix.splice(popup.newPriceOption.value_depends_matrix.indexOf(value), 1);
                            }
                        });
                    };
                    popup.onCancelRuleValue = function () {
                        popup.isRuleValueEdit = false;

                        if (popup.isRuleValueAdd) {
                            popup.ruleValueDeleteClick(popup.editingRule);
                        } else {
                            popup.editingRule.card_category_id = popup.backupRule.card_category_id;
                            popup.editingRule.threshold = popup.backupRule.threshold;
                            popup.backupRule = null;
                            popup.editingRule = null;
                        }

                        popup.isRuleValueAdd = false;
                    };

                    popup.onAddRuleThreshold = function (fromFields) {
                        var value_is_null_index = popup.newPriceOption.value_depends_matrix.findIndex(function (v) {
                            return v.value === null;
                        });

                        if (value_is_null_index !== -1) {

                            if (fromFields['rule_value_' + value_is_null_index])
                                fromFields['rule_value_' + value_is_null_index].$dirty = true;
                            if (fromFields['rule_threshold_' + value_is_null_index])
                                fromFields['rule_threshold_' + value_is_null_index].$dirty = true;
                            return;
                        }

                        popup.newrule = {
                            threshold: 0,
                            value: null
                        };
                        popup.isRuleValueAdd = true;
                        popup.isRuleValueEdit = true;
                        popup.newPriceOption.value_depends_matrix.push(popup.newrule);

                        popup.editingRule = popup.newrule;

                    };

                    popup.onSaveRuleValue = function (item, index, form) {
                        var rule_values_error = false;
                        for (var i in form.$error.required) {
                            if (!rule_values_error && /(rule_value_|rule_threshold_)/.test(form.$error.required[i].$name)) {
                                rule_values_error = true;
                            }
                        }
                        if (item && !rule_values_error) {
                            var existThreshold = false;
                            var existValue = false;

                            popup.newPriceOption.value_depends_matrix.forEach(function (item) {
                                if (!(item == popup.editingRule) && (item.threshold == popup.editingRule.threshold)) existThreshold = true;
                                //if (!(item == popup.editingRule) && (item.value == popup.editingRule.value)) existValue = true;
                            });

                            if (existThreshold) {
                                NotifyService.Warning('Threshold with same value exists!', false);
                                // } else if (existValue) {
                                //   NotifyService.Warning('Price with same value exists!', false);
                            } else {
                                // OK, store
                                popup.isRuleValueEdit = false;
                                popup.isRuleValueAdd = false;
                                popup.editingRule = null;
                                popup.backupRule = null;

                                var orderBy = $filter('orderBy');
                                popup.newPriceOption.value_depends_matrix = orderBy(popup.newPriceOption.value_depends_matrix, 'threshold', false);
                            }

                        } else {
                            if (form['rule_value_' + index])
                                form['rule_value_' + index].$dirty = true;
                            if (form['rule_threshold_' + index])
                                form['rule_threshold_' + index].$dirty = true;
                        }
                    };
                    popup.priceOptionsValueDependsTypes = [
                        {id: 'none', title: 'price_option_value_depends_type#none'},
                        {id: 'amount', title: 'price_option_value_depends_type#amount'},
                        {id: 'quantity', title: 'price_option_value_depends_type#quantity'}
                    ];
                    popup.priceOptionsValueDependsCalcPeriod = [
                        {id: 'all', title: 'For all time'},
                        {id: 'day', title: 'For day'},
                        {id: 'week', title: 'For week'},
                        {id: 'month', title: 'For months'},
                        {id: 'three-month', title: 'For three months'},
                        {id: 'year', title: 'For year'},
                        {id: 'current-week', title: 'For this week (since Monday)'},
                        {id: 'past-week', title: 'For last week (since Monday)'},
                        {id: 'current-month', title: 'For current month (from the 1st)'},
                        {id: 'past-month', title: 'For last month (from the 1st of the last month)'},
                        {id: 'current-quarter', title: 'For current quarter'},
                        {id: 'past-quarter', title: 'For last quarter'},
                        {id: 'current-year', title: 'For current year (since January 1st)'},
                        {id: 'past-year', title: 'For last year (since January 1st of the last year)'}
                    ];

                    popup.priceOptionsValueDependsByGoods = [
                        {id: 'all', title: 'price_option_value_depends_by_goods#all'},
                        {id: 'current', title: 'price_option_value_depends_by_goods#current'}
                    ];

                    popup.priceOptionsTypes = [
                        {id: 'markup', title: 'price_option_type#markup'},
                        {id: 'discount', title: 'price_option_type#discount'},
                        {id: 'value', title: 'price_option_type#value'},
                        {id: 'forbidden', title: 'price_option_type#forbidden'},
                    ];
                    popup.priceOptionsBaseValueTypes = [
                        {id: 'posted-price', title: 'price_option_base_value_type#posted-price'},
                        {id: 'price-including-taxes', title: 'price_option_base_value_type#price-including-taxes'},
                        {id: 'base-price', title: 'price_option_base_value_type#base-price'}
                    ];
                    popup.priceOptionsValueTypes = [
                        {id: 'amount', title: 'price_option_value_type#amount'},
                        {id: 'percentage', title: 'price_option_value_type#percentage'}
                    ];
                    popup.validation = {
                        isItemValid: true,
                        isValueValid: true
                    };
                    popup.changeTitleLang = function (lang) {
                        if (lang === undefined) {
                            lang = $scope.multilang.lang;
                        }

                        popup.categoryLang = lang;
                    };

                    popup.cardCategoryValidator = {
                        isTitleValid: function (formData) {
                            var form = formData || popup.category;
                            return !!form && !!form.title && form.title.length;
                        },
                        isPublicTitleValid: function (formData) {
                            var form = formData || popup.category;

                            if (!formData.public_title) {
                                return false;
                            }
                            var titleNotEmpty = Object.values(form.public_title).find(function (title) {
                                return (title && title.length) > 0 ? true : false;
                            });
                            return titleNotEmpty ? true : false;

                        }
                    };

                    popup.changePriceOptionType = function () {
                        if(popup.newPriceOption.type === 'value'){
                            popup.newPriceOption.base_value_type = 'base-price';
                            popup.newPriceOption.value_type = 'amount';
                        }
                    };

                    function validateCardCategory() {
                        var validationResult = {
                            isValid: true,
                            corruptedFields: []
                        };

                        for (var validatorName in popup.cardCategoryValidator) {
                            var isValid = popup.cardCategoryValidator[validatorName](popup.category);
                            if (!isValid) {
                                validationResult.corruptedFields.push(validatorName);
                                validationResult.isValid = false;
                            }
                        }

                        return validationResult;
                    }

                    popup.saveCategory = function () {
                        var validationResult = validateCardCategory();
                        console.log('saveCategory::validationResult', validationResult);
                        popup.corruptedFields = validationResult.corruptedFields;
                        if (!validationResult.isValid) {
                            return;
                        }

                        console.log('popup.category', popup.category);
                        if (!!popup.category.id) {

                            CorporateCustomerService.EditCorporateCustomersCategories(popup.category, function (success, data) {
                                if (success) {
                                    var catIndex;
                                    angular.forEach($scope.data.corporateCategories, function (category, index) {
                                        if (category.id === data.id) {
                                            catIndex = index;
                                        }
                                    });

                                    $scope.data.corporateCategories[catIndex] = data;
                                    NotifyService.Success('', false);

                                }
                            });
                        } else {

                            console.log('popup.category', popup.category);
                            CorporateCustomerService.AddCorporateCustomersCategories(popup.category, function (success, data) {
                                if (success) {
                                    popup.category = data;
                                    $scope.data.corporateCategories.push(popup.category);
                                    NotifyService.Success('', false);

                                }
                            });

                        }

                    };

                    /*
                     * Price modification
                    */

                    popup.onChangeTab = function (tab) {

                        if (popup.currentTab === 'add_edit_category' && tab !== 'add_edit_category') {
                            var card_category;
                            if (angular.element('#card_category').scope()) {
                                card_category = angular.element('#card_category').scope().card_category;
                            }

                            if (card_category && card_category.$dirty) {
                                var mainPopup = popup;
                                var modalInstance = $uibModal.open({
                                    animation: true,
                                    keyboard: true,
                                    size: 'sm',
                                    templateUrl: 'app/templates/modal.confirmation.html',
                                    controllerAs: 'popup',
                                    controller: function ($uibModalInstance) {
                                        var popup = this;

                                        popup.type = 'profile';

                                        popup.onSaveClick = function () {
                                            if (card_category.$dirty && card_category.$valid) {
                                                mainPopup.saveCategory();
                                                card_category.$setPristine();
                                            }
                                            mainPopup.currentTab = tab;
                                            popup.newPriceOption = undefined;
                                            popup.step = 0;
                                            $uibModalInstance.close();
                                        };

                                        popup.onCancelClick = function () {
                                            mainPopup.currentTab = tab;
                                            popup.newPriceOption = undefined;
                                            popup.step = 0;
                                            $uibModalInstance.close();
                                        };
                                    }
                                });
                            } else {
                                popup.currentTab = tab;
                                popup.newPriceOption = undefined;
                                popup.step = 0;
                            }

                        } else if (popup.currentTab === 'price_modification' && tab !== 'price_modification') {
                            var price_modification;
                            if (angular.element('#price_modification').scope()) {
                                price_modification = angular.element('#price_modification').scope().price_modification;
                            }
                            if (price_modification && price_modification.$dirty) {
                                var mainPopup = popup;
                                var modalInstance = $uibModal.open({
                                    animation: true,
                                    keyboard: true,
                                    size: 'sm',
                                    templateUrl: 'app/templates/modal.confirmation.html',
                                    controllerAs: 'popup',
                                    controller: function ($uibModalInstance) {
                                        var popup = this;

                                        popup.type = 'profile';

                                        popup.onSaveClick = function () {
                                            if (price_modification.$dirty && price_modification.$valid) {
                                                mainPopup.savePriceOption();
                                                price_modification.$setPristine();
                                                mainPopup.currentTab = tab;
                                                popup.newPriceOption = undefined;
                                                popup.step = 0;
                                            } else {
                                                mainPopup.savePriceOption();
                                            }

                                            $uibModalInstance.close();
                                        };

                                        popup.onCancelClick = function () {
                                            mainPopup.currentTab = tab;
                                            popup.newPriceOption = undefined;
                                            popup.step = 0;
                                            $uibModalInstance.close();
                                        };
                                    }
                                });
                            } else {
                                popup.currentTab = tab;
                            }

                        }

                    };

                    popup.getSpecialAccounts = function () {
                        BusinessService.SpecialAccountsParams({scope: 'corporate'}, function (success, data) {
                            if (success) {
                                popup.data.accountsList = data;
                            }
                        });
                    };
                    popup.getSpecialAccounts();
                    popup.data.showPriceOptions = function (account) {
                        popup.step = 1;
                        popup.selectedSpecialAccount = account;
                        popup.refreshPriceOptions();

                    };
                    popup.data.modalTaxesExempt = function (corporateCategory, corporateCustomerSpecialAccount) {
                        TaxesExemptInCorporateService.TaxesExempt(
                            {
                                corporateCategory: corporateCategory,
                                corporateCustomerSpecialAccount: corporateCustomerSpecialAccount
                            }
                        );
                    };
                    popup.cancelPriceOption = function () {
                        popup.newPriceOption = undefined;
                        popup.validation.isItemValid = true;
                        popup.validation.isValueValid = true;
                        popup.step = 0;
                    };
                    popup.deletePriceOption = function (priceOption) {
                        CorporateCustomerService.DeleteCorporateCustomersCategoryPriceOptions(
                            popup.category.id,
                            popup.selectedSpecialAccount.id,
                            priceOption.item_id,
                            function (success, data) {
                                if (success) {
                                    NotifyService.Success('', false);
                                    popup.step = 1;
                                    popup.refreshPriceOptions(function () {
                                        popup.newPriceOption = undefined;
                                    });
                                } else {
                                    popup.loading = false;
                                }

                            });
                    };

                    popup.editPriceOption = function (row) {
                        popup.step = 2;
                        popup.newPriceOption = row;
                    };
                    popup.refreshPriceOptions = function (callback) {
                        var params = {
                            category_id: popup.category.id,
                            account_id: popup.selectedSpecialAccount.id
                        };
                        CorporateCustomerService.GetCorporateCustomersCategoryPriceOptions(params, function (success, data) {
                            if (success) {
                                popup.priceOptions = data;
                                if (callback) {
                                    callback();
                                }
                            }
                        });
                    };
                    popup.AddPriceOption = function () {
                        popup.step = 2;
                        BusinessService.getSpecialAccountGoods(popup.selectedSpecialAccount.id, function (success, data) {
                            if (success) {
                                popup.availableSpecialAccountGoods = data;

                                popup.newPriceOption = {
                                    type: 'markup',
                                    base_value_type: 'posted-price',
                                    value_type: 'amount',
                                    value: null,
                                    value_depends_type: 'none'
                                };
                                popup.loading = true;
                            }
                        });
                    };
                    popup.savePriceOption = function () {
                        var priceOption = angular.copy(popup.newPriceOption);
                        console.log('savePriceOption::priceOption', priceOption);
                        if(priceOption.type !== 'forbidden') {
                            popup.validation.isValueValid = priceOption.value !== null && priceOption.value !== undefined && priceOption.value_depends_type === 'none';
                        } else {
                            popup.validation.isValueValid = true;
                        }

                        popup.validation.isItemValid = !!priceOption.item_id;

                        console.log('savePriceOption::priceOption', priceOption);

                        var invalidPriceOption = false;

                        if(priceOption.type !== 'forbidden') {
                            if (priceOption.value_depends_type === 'none' && (priceOption.value === null || priceOption.value === undefined)) {
                                invalidPriceOption = priceOption.value === undefined || priceOption.value === null;
                            } else if (priceOption.value_depends_type !== 'none') {
                                var isInvalidIndex = (popup.newPriceOption.value_depends_matrix || []).findIndex(function (row) {
                                    return row.value === null;
                                });
                                if (isInvalidIndex !== -1) {
                                    invalidPriceOption = true;
                                }
                            }
                        }
                        console.log('savePriceOption::invalidPriceOption', invalidPriceOption);
                        if (!priceOption.item_id || invalidPriceOption) {
                            return;
                        }
                        popup.loading = true;

                        if (priceOption.item_title) {
                            console.log('popup.savePriceOption', priceOption);
                            CorporateCustomerService.EditCorporateCustomersCategoryPriceOptions(
                                popup.category.id,
                                popup.selectedSpecialAccount.id,
                                priceOption.item_id,
                                priceOption,
                                function (success, data) {
                                    if (success) {
                                        NotifyService.Success('', false);
                                        popup.step = 1;
                                        popup.refreshPriceOptions(function () {
                                            popup.newPriceOption = undefined;
                                        });
                                    } else {
                                        popup.loading = false;
                                    }

                                });
                        } else {

                            CorporateCustomerService.AddCorporateCustomersCategoryPriceOptions(
                                popup.category.id,
                                popup.selectedSpecialAccount.id,
                                priceOption,
                                function (success, data) {
                                    if (success) {
                                        NotifyService.Success('', false);
                                        popup.step = 1;
                                        popup.refreshPriceOptions(function () {
                                            popup.newPriceOption = undefined;
                                        });
                                    } else {
                                        popup.loading = false;
                                    }

                                });
                        }
                    };

                    popup.changeValue = function () {
                        popup.validation.isValueValid = true;
                    };

                    popup.changeItem = function () {
                        popup.validation.isItemValid = true;
                    };

                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                    };

                }
            });
        };

    }
})();
